import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { AdminService } from "./admin.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard {
  constructor(private router: Router, private admin: AdminService) { }
  canActivate() {
    let token = localStorage.getItem("adminToken");
    if (token) {
      return true;
    }

    this.router.navigate([""]);
    return false;
  }
}
